<!-- Copyright by the Spark Development Network; Licensed under the Rock Community License -->
<template>
    <DatePartsPicker v-model="internalValue" :showYear="false" />
</template>

<script setup lang="ts">
    import { PropType, computed } from "vue";
    import DatePartsPicker, { DatePartsPickerValue, getDefaultDatePartsPickerModel } from "./datePartsPicker";
    import { MonthDayValue } from "@Obsidian/ViewModels/Controls/monthDayValue";

    const props = defineProps({
        modelValue: {
            type: Object as PropType<MonthDayValue>,
            default: getDefaultDatePartsPickerModel
        }
    });

    const emit = defineEmits<{
        (e: "update:modelValue", _value: MonthDayValue): void
    }>();

    const internalValue = computed<DatePartsPickerValue>({
        get() {
            return Object.assign({}, props.modelValue, { year: 0 });
        },
        set(newVal) {
            const value: MonthDayValue = {
                month: newVal.month,
                day: newVal.day
            };
            emit("update:modelValue", value);
        }
    });
</script>
